import { Refresh2Light, SensorsLightCustom } from '@repo/go-icons';
import { ActionsBar, Button, RadioGroup, Scrollbar, Tooltip } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { ImageBroadcastingWidgetState } from '../../model/ImageBroadcastingWidgetState';
import styles from '../Broadcast.module.scss';

type Props = {
  widgetState: ImageBroadcastingWidgetState;
};

const BroadcastsSelect = observer(function BroadcastsSelect({ widgetState }: Props) {
  const { t } = useTranslation('imageBroadcast');

  function onSelect(id: number) {
    const broadcast = widgetState.imageBroadcasts.list.find((obj) => obj.id === String(id));
    if (broadcast) {
      widgetState.setBroadcast(broadcast);
    }
  }

  const selected = widgetState.selectedBroadcast?.id ?? null;

  return (
    <div className={styles.BroadcastsSelectTooltip}>
      <Scrollbar wrapperClassName={styles.BroadcastsSelectTooltipScrollWrapper}>
        <div className={styles.BroadcastsSelectTooltipContent}>
          <RadioGroup
            onChange={(value) => onSelect(Number(value))}
            value={selected}
            items={widgetState.imageBroadcasts.sortedList.map((broadcast) => ({
              label: broadcast.text,
              value: Number(broadcast.id),
            }))}
          />
        </div>
      </Scrollbar>
      <div className={styles.BroadcastsSelectTooltipFooter}>
        <Button
          variant="flat"
          icon={<Refresh2Light />}
          onClick={() => {
            widgetState.refetchBroadcasts();
          }}
          style={{ paddingLeft: 0 }}
        >
          {t('updateList')}
        </Button>
      </div>
    </div>
  );
});

export const BroadcastsSelectPanel = observer(function BroadcastsSelectPanel({ widgetState }: Props) {
  const { t } = useTranslation('imageBroadcast');
  const [open, setOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setTooltipOpen(false);
    }
  }, [open]);

  return (
    <Tooltip
      open={tooltipOpen && !open}
      onOpenChange={(value) => setTooltipOpen(value)}
      placement="left"
      title={t('broadcastsSelection')}
    >
      <ActionsBar.Item active={open} onClick={() => setOpen(true)}>
        <Tooltip
          open={open}
          title={
            widgetState.imageBroadcasts.list.length > 0 ? (
              <BroadcastsSelect widgetState={widgetState} />
            ) : (
              <span>{t('broadcastsEmpty')}</span>
            )
          }
          trigger={['click']}
          onOpenChange={(value) => setOpen(value)}
          placement="left"
        >
          <SensorsLightCustom />
        </Tooltip>
      </ActionsBar.Item>
    </Tooltip>
  );
});
